// Copyright (c) Bentley Systems
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

type confirmationState = {
  isConfirmationOpen: boolean;
  caption?: string;
  text?: string;
  okText?: string;
  cancelText?: string;
  onOkAction?: () => void;
  showCheckbox?: boolean;
  checkboxLabel?: string;
  checkboxChecked?: boolean;
  onCheckboxChange?: (checked: boolean) => void;
  showColorPicker?: boolean;
  colorPickerLabel?: string;
  colorPickerValue?: string;
  onColorChange?: (color: string | null) => void;
};

const initialState: confirmationState = {
  isConfirmationOpen: false,
};

export const confirmationSlice = createSlice({
  name: "confirmation",
  initialState,
  reducers: {
    setConfirmation: (state, action: PayloadAction<confirmationState>) => {
      state.isConfirmationOpen = action.payload.isConfirmationOpen;
      state.onOkAction = action.payload.onOkAction;
      state.caption = action.payload.caption;
      state.text = action.payload.text;
      state.okText = action.payload.okText;
      state.cancelText = action.payload.cancelText;
      state.showCheckbox = action.payload.showCheckbox;
      state.checkboxLabel = action.payload.checkboxLabel;
      state.checkboxChecked = action.payload.checkboxChecked;
      state.onCheckboxChange = action.payload.onCheckboxChange;
      state.showColorPicker = action.payload.showColorPicker;
      state.colorPickerLabel = action.payload.colorPickerLabel;
      state.colorPickerValue = action.payload.colorPickerValue;
      state.onColorChange = action.payload.onColorChange;
    },
  },
});

export const { setConfirmation } = confirmationSlice.actions;

export const selectConfirmation = (state: RootState) => state.confirmation;

export default confirmationSlice.reducer;
